import posthog, { type PostHog, type PostHogConfig } from "posthog-js";

import { maskReplayText } from "./maskReplayText";
import { getPostHogConfig } from "./posthogConfig";

const POSTHOG_UI_HOST = "https://eu.posthog.com";

let initialised = false;

export function initPostHog(): PostHog | null {
  if (typeof window === "undefined") return null;

  if (initialised) return posthog;

  const { enabled, key, host, sessionRecordingEnabled } = getPostHogConfig();

  if (!enabled || !key) return null;

  try {
    posthog.init(key, buildPostHogOptions(host, sessionRecordingEnabled));
    initialised = true;

    return posthog;
  } catch {
    return null;
  }
}

function buildPostHogOptions(
  host: string,
  sessionRecordingEnabled: boolean,
): Partial<PostHogConfig> {
  return {
    api_host: host,
    ui_host: POSTHOG_UI_HOST,

    defaults: "2026-01-30",
    capture_pageleave: true,
    autocapture: true,
    person_profiles: "identified_only",

    mask_all_element_attributes: true,
    mask_personal_data_properties: true,
    custom_personal_data_properties: [
      "code",
      "registrationCode",
      "redirect",
      "email",
      "username",
    ],

    disable_session_recording: !sessionRecordingEnabled,
    session_recording: {
      maskAllInputs: true,
      maskTextClass: "ph-mask",
      maskTextSelector: "*",
      maskTextFn: maskReplayText,
      blockClass: "ph-no-capture",
    },
  };
}

export function resetPostHogInitForTests(): void {
  initialised = false;
}
